import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import OutboxSummary from './components/OutboxSummary';
import OutboxTable from './components/OutboxTable';
import useAdminWhatsAppOutbox from './hooks/useAdminWhatsAppOutbox';

/**
 * AdminWhatsAppOutbox - Fila de envio de WhatsApp da plataforma (Admin Geral)
 *
 * Responsabilidades:
 * - Consome useAdminWhatsAppOutbox() para o resumo da fila e a lista paginada/filtrada
 *   de company_whatsapp_outbox (admin/whatsapp/outbox.php)
 * - Renderiza AreaTitle + botão "Atualizar" + cards de resumo + tabela com filtros e
 *   paginação server-side, com os filtros vivendo na URL para que o link possa ser
 *   compartilhado
 *
 * Tela somente leitura: nada aqui altera a fila.
 */
function AdminWhatsAppOutbox() {
  const {
    rows,
    pagination,
    summary,
    filterOptions,
    isLoading,
    error,

    status,
    setStatus,
    companyInput,
    setCompanyInput,
    automationType,
    setAutomationType,
    messageKind,
    setMessageKind,
    priority,
    setPriority,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    late,
    toggleLate,
    setPage,
    refresh,
  } = useAdminWhatsAppOutbox();

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <AreaTitle
          Title="Admin Geral · Fila WhatsApp"
          Icon={<ScheduleSendIcon />}
          Description="Agenda de envios da fila de WhatsApp (company_whatsapp_outbox): o que está para sair, o que saiu e o que falhou. Somente leitura."
        />

        <Button
          variant="outlined"
          startIcon={<RefreshOutlinedIcon />}
          onClick={() => refresh()}
          disabled={isLoading}
        >
          Atualizar
        </Button>
      </Box>

      <OutboxSummary summary={summary} late={late} onToggleLate={toggleLate} />

      <OutboxTable
        rows={rows}
        isLoading={isLoading}
        error={error}
        pagination={pagination}
        late={late}
        filters={{
          status,
          onStatusChange: setStatus,
          companyInput,
          onCompanyInputChange: setCompanyInput,
          automationTypes: filterOptions.automation_types,
          automationType,
          onAutomationTypeChange: setAutomationType,
          messageKinds: filterOptions.message_kinds,
          messageKind,
          onMessageKindChange: setMessageKind,
          priority,
          onPriorityChange: setPriority,
          dateFrom,
          onDateFromChange: setDateFrom,
          dateTo,
          onDateToChange: setDateTo,
        }}
        onPageChange={setPage}
      />
    </Box>
  );
}

export default AdminWhatsAppOutbox;
